import { render, staticRenderFns } from "./SetIndex.vue?vue&type=template&id=059e81ca&scoped=true&"
import script from "./SetIndex.vue?vue&type=script&lang=js&"
export * from "./SetIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059e81ca",
  null
  
)

export default component.exports